// extracted by mini-css-extract-plugin
export default {"productWrapper":"pYBm5A","imageContainer":"YYBiyb","active":"PTxnU2","productImage":"L4O001","iconContainer":"BMlmru","fadeIn":"kMr7wL","checkmark":"WK3d9o"};